import { omniContractCreateButtonConfig } from "@/services/backend/omni/servicekindrules/omni-contract-create-button-config";
import { ReactNode, useCallback, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router";
import { CardSkeleton } from "@/shared/components/card-skeleton";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useOmniOfferShowQuery } from "@/services/backend/omni/offer/api/offer-api";
import { ListRequest } from "@/services/backend/omni/contract/api/contract-api";
import { ContractCreateButton } from "@/services/backend/omni/contract/components/contract-create-button";
import { ContractTable } from "@/services/backend/omni/contract/components/contract-table";

export function OfferContractsRoute() {
  const { offerId } = useParams();
  const navigate = useNavigate();
  const {
    data: offer,
    isLoading,
    error,
  } = useOmniOfferShowQuery({
    id: offerId!,
  });
  const [request, setRequest] = useState<ListRequest>({
    offerId: { active: true, values: [offerId!] },
    orderBy: [{ field: "createdAt" }],
    limit: 50,
    offset: 0,
  });

  const renderRowLink = useCallback(
    (id: string, children: ReactNode) => <NavLink to={id}>{children}</NavLink>,
    [],
  );

  return (
    <div>
      {error && <RTKQueryErrorAlert error={error} />}
      {isLoading && <CardSkeleton />}
      {offer && (
        <ContractTable
          request={request}
          onRequestChange={setRequest}
          renderRowLink={renderRowLink}
          actions={
            <ContractCreateButton
              offer={offer}
              config={omniContractCreateButtonConfig}
              onCreated={(id) => navigate(id)}
            />
          }
        />
      )}
    </div>
  );
}
